module.exports = __webpack_public_path__ + "img/multiple.d2e73219.png";